import React, { FC } from "react";
import { IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import clsx from "clsx";
import sideBarStyles from "./sidebar.module.css";
import { ImgURL } from "../../../Url";
import { SectionsList } from "./SideBarInterface";

interface SectionListItemPropsInterface {
  value: SectionsList;
  onClick: (id: string) => void;
  onCollapse: (id: string) => void;
  selected: boolean;
  collapse: boolean;
  expandButton: boolean;
}
//eslint-disable-next-line
const ListItemSmeta: FC<SectionListItemPropsInterface> = ({
  value: { ID: id, Image: img, Name: name, Title: title, $tag },
  selected,
  expandButton,
  collapse,
  onCollapse,
  onClick,
}) => {
  const theme = "light";

  const handleExpand = () => {
    onCollapse(id);
  };
  const handleClick = () => {
    onClick(id);
  };

  return (
    <ListItem
      component="div"
      style={{
        padding: 0,
        display: "inherit",
      }}
      sx={{
        "& .MuiListItemSecondaryAction-root": {
          right: "auto",
          left: Number($tag) * 20 + "px",
        },
      }}
      secondaryAction={
        <IconButton
          id={id}
          onClick={handleExpand}
          className={clsx(sideBarStyles.ExpandButton)}
          style={{ display: expandButton ? "inline-flex" : "none" }}
        >
          {collapse ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </IconButton>
      }
    >
      <ListItemButton
        style={{ paddingRight: 0, color: "white" }}
        component="div"
        sx={{
          //   pl: img ? howDeep : "",
          paddingLeft: Number($tag) * 30 + "px",
          "& .Mui-selected": {
            backgroundColor: "rgb(35, 114, 191)",
          },
        }}
        id={id}
        selected={selected}
        onClick={handleClick}
      >
        <ListItemIcon
          style={{
            minWidth: "0px",
            paddingRight: "10px",
            paddingLeft: 10,
            display: !img ? "none" : "grid",
          }}
        >
          {img ? ImgURL(img, { height: 32 }) : ""}
        </ListItemIcon>
        <ListItemText
          className={clsx("fontColorStimate", {
            light: theme === "light",
          })}
          primary={
            <div className={clsx(sideBarStyles.ListItemText)} title={title || name}>
              {title || name}
            </div>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};

export default ListItemSmeta;
